import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-auto mb-4 md:w-2/5 hide-in-thumbnail hidden"
}
const _hoisted_2 = { class: "user-content relative" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 0,
  class: "ml-2 icon-light inline-icon material-icons-outlined"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-8 text-center text-muted" }
const _hoisted_8 = {
  key: 0,
  class: "relative flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1 text-base material-icons" }, " play_arrow ", -1)
const _hoisted_10 = {
  key: 0,
  class: "opacity-50"
}
const _hoisted_11 = {
  key: 1,
  class: "opacity-0"
}
const _hoisted_12 = { class: "mx-auto mb-2 md:w-full hide-in-thumbnail" }
const _hoisted_13 = { class: "relative user-content mx-2 programming-exercise-text" }
const _hoisted_14 = {
  key: 0,
  class: "absolute bottom-0 right-0"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = {
  key: 0,
  class: "ml-2 icon-light inline-icon material-icons-outlined"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "mt-8 text-center text-muted" }
const _hoisted_20 = { class: "flex items-center p-3 pl-4 space-x-2 rounded-tr-sm bg-gray-50" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "my-auto material-icons-outlined icon-light" }, " code ", -1)
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "mx-auto mt-24 opacity-30 text-8xl material-icons-outlined" }, " code ", -1)
const _hoisted_24 = { class: "px-4 mx-auto select-none text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "absolute bottom-0 right-0 z-50 flex items-center px-6 py-3 mb-2 mr-4 space-x-2 rounded bg-dark text-lightText bg-opacity-90 shadow-popup"
}
const _hoisted_26 = { class: "w-full mt-4" }
const _hoisted_27 = { class: "ml-2 text-sm text-muted" }
const _hoisted_28 = {
  key: 0,
  class: "mt-4 card card-filled"
}
const _hoisted_29 = { class: "ml-2 text-sm text-muted" }
const _hoisted_30 = { class: "w-full mt-4" }
const _hoisted_31 = { class: "ml-2 text-sm text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_ExerciseTestCase = _resolveComponent("ExerciseTestCase")!
  const _component_ExerciseHintButton = _resolveComponent("ExerciseHintButton")!
  const _component_CodeExecutionResults = _resolveComponent("CodeExecutionResults")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_CodeEditor = _resolveComponent("CodeEditor")!
  const _component_CodeFragment = _resolveComponent("CodeFragment")!
  const _component_AbstractExercise = _resolveComponent("AbstractExercise")!

  return (_openBlock(), _createBlock(_component_AbstractExercise, _normalizeProps(_guardReactiveProps(_ctx.$props)), {
    exerciseText: _withCtx(() => [
      (_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Tabs, {
              modelValue: _ctx.currentTab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTab) = $event)),
              options: _ctx.filteredTabsOptions
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          innerHTML: _ctx.exercise.text
        }, null, 8, _hoisted_3)
      ], 512), [
        [_vShow, _ctx.readOnly && _ctx.currentTab === _ctx.ProgrammingExerciseTabs.TEXT]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercise.testcases, (testcase, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "my-8",
            key: 't-' + testcase.id
          }, [
            _createElementVNode("h4", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t("programming_exercise.testcase")) + " " + _toDisplayString(index + 1) + " ", 1),
              (!testcase.code && !testcase.text && !testcase.stdin)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "visibility_off"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_ExerciseTestCase, { "test-case": testcase }, null, 8, ["test-case"])
          ]))
        }), 128)),
        (_ctx.exercise.testcases?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("programming_exercise.no_testcases")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, _ctx.readOnly && _ctx.currentTab === _ctx.ProgrammingExerciseTabs.TEST_CASES]
      ])
    ]),
    submissionControls: _withCtx(() => [
      (true || _ctx.currentTab === _ctx.ProgrammingExerciseTabs.EDITOR)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_CodeEditor, {
              language: _ctx.languageCode,
              class: "w-full",
              size: 'lg',
              modelValue: _ctx.proxyModelValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.proxyModelValue) = $event)),
              showRunButton: true,
              runCoolDown: _ctx.runCoolDown,
              running: _ctx.isRunning || _ctx.runCoolDown > 0,
              onRun: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRun())),
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('blur')))
            }, {
              runButton: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(_toDisplayString(_ctx.$t("programming_exercise.run_code")) + " ", 1),
                (_ctx.runCoolDown > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (" + _toDisplayString(_ctx.runCoolDown) + ")", 1))
                  : _createCommentVNode("", true),
                (_ctx.runCoolDown < 10)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "0"))
                  : _createCommentVNode("", true)
              ]),
              sidePaneTitle: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Tabs, {
                    modelValue: _ctx.currentTab,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentTab) = $event)),
                    options: _ctx.filteredTabsOptions
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              sidePane: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  (_ctx.showHintButton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_ExerciseHintButton, {
                          exerciseId: _ctx.exercise.id,
                          submission: _ctx.submission
                        }, null, 8, ["exerciseId", "submission"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: _ctx.exercise.text
                  }, null, 8, _hoisted_15)
                ], 512), [
                  [_vShow, _ctx.currentTab === _ctx.ProgrammingExerciseTabs.TEXT]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercise.testcases, (testcase, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "my-8 mx-2",
                      key: 't-' + testcase.id
                    }, [
                      _createElementVNode("h4", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t("programming_exercise.testcase")) + " " + _toDisplayString(index + 1) + " ", 1),
                        (!testcase.code && !testcase.text && !testcase.stdin)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "visibility_off"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_ExerciseTestCase, { "test-case": testcase }, null, 8, ["test-case"])
                    ]))
                  }), 128)),
                  (_ctx.exercise.testcases?.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t("programming_exercise.no_testcases")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.currentTab === _ctx.ProgrammingExerciseTabs.TEST_CASES]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("programming_exercise.execution_results")), 1)
                  ]),
                  (_ctx.submission.execution_results)
                    ? (_openBlock(), _createBlock(_component_CodeExecutionResults, {
                        key: 0,
                        executionResults: _ctx.submission.execution_results,
                        testCases: _ctx.exercise.testcases
                      }, null, 8, ["executionResults", "testCases"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("programming_exercise.code_execution_will_appear_here")), 1)
                      ]))
                ], 512), [
                  [_vShow, _ctx.currentTab === _ctx.ProgrammingExerciseTabs.EXECUTION_RESULTS]
                ])
              ]),
              bottom: _withCtx(() => [
                _createVNode(_Transition, { name: "quick-bounce" }, {
                  default: _withCtx(() => [
                    (_ctx.executionState === 'running')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_Spinner, { fast: true }),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("programming_exercise.running_code")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["language", "modelValue", "runCoolDown", "running"])
          ]))
        : _createCommentVNode("", true)
    ]),
    readOnlyAnswer: _withCtx(() => [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("event_assessment.text_answer_label")), 1),
        _createVNode(_component_CodeFragment, {
          value: _ctx.submission.answer_text,
          defaultValue: _ctx.$t('misc.no_answer')
        }, null, 8, ["value", "defaultValue"]),
        (_ctx.submission.execution_results)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$t("programming_exercise.execution_results")), 1),
              _createVNode(_component_CodeExecutionResults, {
                class: "-mx-2",
                testCases: _ctx.exercise.testcases,
                executionResults: _ctx.submission.execution_results,
                reduced: true
              }, null, 8, ["testCases", "executionResults"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    solution: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("misc.solution")), 1),
        _createVNode(_component_CodeFragment, {
          value: _ctx.exercise.solution
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }, 16))
}